import {
    LOADING_UI,
    CLEAR_ERRORS,
    GET_PRODUCTS_LIST,
    SUBMIT_ENQUIRY_FORM,
    UPDATE_PRODUCT_SERVICES,
    COMPANY_LOGO
} from "../type";

const initialState = {
    productList: [],
    enquiryResponse: {},
    companyLogo: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUBMIT_ENQUIRY_FORM:
            return {
                ...state,
                enquiryResponse: action.payload
            };
        case COMPANY_LOGO:
            return {
                ...state,
                companyLogo: action.payload
            };
        case GET_PRODUCTS_LIST:
            return {
                ...state,
                productList: action.payload,
            }
        case UPDATE_PRODUCT_SERVICES:
            return {
                ...state,
                productList: action.payload,
            }
        default:
            return state;
    }


}